import styles from "./EventImages.module.scss";
import classNames from "classnames";
import { EventImagesProps } from "../../../../types/props";
import { useMemo, useState, useCallback } from "react";
import { ImageGalleryModal } from "../ImageGalleryModal/ImageGalleryModal";

type GalleryImage = {
  src: string;
  alt?: string;
};

export const EventImages = ({ mainImage, images }: EventImagesProps) => {
  const countImages: number = images?.length || 0;

  const galleryImages: GalleryImage[] = useMemo(() => {
    const extra =
      images?.map((img, i) => ({
        src: img.medium,
        alt: `Изображение мероприятия ${i + 2}`,
      })) || [];

    return [{ src: mainImage, alt: "Изображение мероприятия 1" }, ...extra];
  }, [mainImage, images]);

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = useCallback((startIndex: number) => {
    setCurrentIndex(startIndex);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => setIsOpen(false), []);

  const hasImages = galleryImages.length > 0;
  const handlePrev = useCallback(() => {
    if (!hasImages) return;
    setCurrentIndex(
      (prev) => (prev - 1 + galleryImages.length) % galleryImages.length
    );
  }, [galleryImages.length, hasImages]);

  const handleNext = useCallback(
    () => setCurrentIndex((prev) => (prev + 1) % galleryImages.length),
    [galleryImages.length]
  );

  return (
    <>
      <div className={styles.imagesWrapper}>
        <img
          className={styles.mainImage}
          src={mainImage}
          alt="Изображение мероприятия 1"
        />

        <div className={styles.secondaryImages}>
          {countImages > 0 && (
            <img
              className={classNames(styles.secondImage, {
                [styles.secondImageFullWidth]: countImages === 1,
              })}
              src={images?.[0].medium}
              alt="Изображение мероприятия 2"
            />
          )}

          {countImages === 2 && (
            <img
              className={styles.thirdImage}
              src={images?.[1].medium}
              alt="Изображение мероприятия 3"
            />
          )}

          {countImages > 2 && (
            <div className={styles.moreImages} onClick={() => openModal(0)}>
              <img
                className={styles.thirdImage}
                src={images?.[2].medium}
                alt="Изображение мероприятия 3"
              />
              {countImages >= 3 && (
                <span className={styles.moreText}>+ {countImages - 2}</span>
              )}
            </div>
          )}
        </div>
      </div>

      {isOpen && (
        <ImageGalleryModal
          images={galleryImages}
          currentIndex={currentIndex}
          onClose={closeModal}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </>
  );
};
